import styled from 'styled-components';

export const ProgressBarWrapper = styled.div`
  padding: 1em;
`;

export const Wrapper = styled.div`
  padding: 1em;
`;
